
/* tab initial stauts, labels can be updated from weblandguage,
UI tabs ordered in the same order as the object */
export const tabDefinition = {
  alberta: { label: 'Status in Alberta', show: false },
  osr: { label: 'Oil Sands Region Status', show: false },
  mammalOsr: { label: 'Mammal Oil Sands Region Status', show: false },
  overview: { label: 'Species Overview', show: false },
  // wetland: 'Status in Wetlands',
  // climate: 'Climate Change vulnerability'
}

export const DATA_MODEL = {
  full: 1,
  few: 2,
  basic: 3
}

export const defaultTab = 'alberta';

export const statusTabSections = [
  ['habSuitability', 'hasMap'],
  ['habHFAssociation', 'hasHabitatSection'],
  ['impactHF', 'hasHFSection']
];

export const osrTabSections = [
  'osrOccurrenceSection', 'osrHfImpactSection', 'osrHfTabSection'
];

export const osrMammalTabSections = [
  'onOffChart', 'edgeDistanceChart'
];

export const osrHFTabs = [
  { label: 'Seismic Lines', name: 'SeismicLines' },
  { label: 'Pipelines', name: 'Pipelines' },
  { label: 'Mine Sites', name: 'MineSites' },
  { label: 'Industrial Facilities', name: 'IndustrialFacilities' },
  { label: 'Well Sites', name: 'WellSites' },
];

export const suitablityMapNames = ['Current', 'Reference', 'Difference'];
export const occurrenceMapName = 'Occurrence';
// sql select '''' || SGD_NAME || ''',' from SPECIES_GUILD_DEFINITIONS where sgd_id > 714
/* bird, mammal, amphibian */
const conservationGuilds2020 = {
  label: 'Conservation Status',
  list: [
    'SARA Status (Schedule 1)',
    'COSEWIC Status',
    'Legal Status AB',
    'ESCC Status AB',
    { name: 'General Status AB', label: 'General Status AB (2020)' },
    'ACIMS Status (2022)',
  ]
};
/* other groups */
const conservationGuilds2010 = {
  label: 'Conservation Status',
  list: [
    'SARA Status (Schedule 1)',
    'COSEWIC Status',
    'Legal Status AB',
    'ESCC Status AB',
    { name: 'General Status AB', label: 'General Status AB (2010)' },
    'ACIMS Status (2022)',
  ]
};
/* conservation referencec, the value are the keys in the web lanaguge app, e.g. acmis */
export const conservationReferenceDef = {
  'General Status AB': ['abStatusCommonAnimal', 'abStatusOther'],
  'ESCC Status AB': 'esccAbLegal',
  'Legal Status AB': 'esccAbLegal',
  'ACIMS Status (2022)': 'acims',
  'COSEWIC Status': 'cosewicSara',
  'SARA Status (Schedule 1)': 'cosewicSara'
};
// const sppStatusGuilds = {
//   label: 'Species Status',
//   list: [
//     'Non-native Plants',
//     'Old Forest Birds'
//   ]
// };
// Wetland+Indicator+Status
const wetlandGuilds = {
  label: 'Wetland Indicator Status',
  list: [
    'Grassland Natural Region',
    'Other Natural Regions'
  ]
};
const plantsGuilds = {
  conservationGuilds2010,
  // sppStatusGuilds,
  wetlandGuilds
}
const birdsGuilds = {
  conservationGuilds2020,
  // sppStatusGuilds
}
const commonGuilds = {
  conservationGuilds2010
}

export const guilds = {
  'Vascular Plants': plantsGuilds,
  Birds: birdsGuilds,
  Mammals: birdsGuilds,
  Amphibians: birdsGuilds,
  other: commonGuilds
}

export const taxonomic = {
  bird: 'Birds',
  plant: 'Vascular Plants',
  mite: 'Soil Mites',
  lichen: 'Lichens',
  moss: 'Bryophytes',
  invertbrate: 'Aquatic Inverterbrates',
  mammal: 'Mammals',
  nnplant: 'Non-native Vascular Plants',
  habitat: 'Habitat Elements',
  amphibian: 'Amphibians'
};

export function getSingleDisplaySpeciesName (species, group) {
  if (!species) {
    return '';
  }

  if (group === taxonomic.habitat) {
    return species?.commonName;
  } else if (species.commonName) {
    return species?.commonName;
  } else {
    return `<i>${species?.scientificName}</i>`;
  }
}
/* bird and mamall use common name, rest use scientific name */
export function getSpeciesNameByGroup (species, group) {
  if (!species) {
    return '';
  }

  if (group === taxonomic.habitat) {
    return species?.commonName;
  } else if (['Birds', 'Mammals'].includes(group)) {
    return species?.commonName;
  } else {
    return species?.scientificName;
  }
}

export function getCombinedDisplaySpeciesName (species) {
  if (!species) {
    return '';
  }
  if (species?.sppGroup?.groupName === taxonomic.habitat) {
    return species?.sppName;
  } else if (species?.commonName) {
    return `${species?.commonName} (<i>${species.scientificName}</i>)`;
  }
  return `<i>${species?.scientificName}</i>`;
}

/* photos */
// xl: 1000 la; 756 me: 600 sm: 400 square: sq
const PHOTO_SIZE = {
  banner: {
    suffix: 'la',
    width: 1000
  },
  pullout: {
    suffix: 'sm',
    width: 400
  },
  habitat: {
    suffix: 'sm',
    width: 400
  },
  characteristics: {
    suffix: 'sm',
    width: 400
  },
  tab: {
    suffix: 'la',
    width: 1000
  },
  naturelynx: {
    suffix: 'me',
    width: 400
  },
}

export function formatPhotoPath (photo, photoType) {
  const orgUrl = import.meta.env.VITE_APP_PHOTO_URL_ORGPHOTO_PREFIX;
  const paths = photo.path.split('.'); // e.g. ./upload/xxx/xxx/xxx.jpg
  const orgFile = paths[1] + '.' + paths[2];
  const fullPaths = []
  if ((PHOTO_SIZE[photoType]?.width || 0) < photo.width) {
    const prefixUrl = import.meta.env.VITE_APP_PHOTO_URL_PREFIX;
    fullPaths.push(prefixUrl + paths[1] + (PHOTO_SIZE[photoType] ? ('-' + PHOTO_SIZE[photoType].suffix) : '') + '.' + paths[2]);
  } else {
    fullPaths.push(orgUrl + orgFile);
  }
  fullPaths.push(orgUrl + orgFile);
  return fullPaths;
}

export const titleFontStyle = {
  color: '#666',
  'font-family': '"Arial"',
  'font-weight': '600',
  'font-size': '1rem'
};

export const axisFontStyle = {
  color: '#666',
  'font-family': '"Arial"',
  'font-weight': '600',
  'font-size': '1rem'
};

export const tickFontStyle = {
  color: '#666',
  'font-family': '"Arial"',
  'font-weight': '600',
  'font-size': '0.8rem'
};

export const smallTickFontStyle = {
  color: '#666',
  'font-family': '"Arial"',
  'font-weight': '600',
  'font-size': '0.6rem'
};

export const yTickLabelFormatter2 = {
  formatter: function () {
    return this.value.toFixed(2);
  }
};

export const yTickLabelFormatter0 = {
  formatter: function () {
    return this.value.toFixed(0);
  }
};

export const defaultXAxis = {
  visible: true,
  lineWidth: 1,
  tickLength: 0,
  tickWidth: 0, // to remove grouped label grid lines
  lineColor: '#666',
  labels: {
    style: tickFontStyle
  }
};

export const defaultYAxis = {
  visible: true,
  lineWidth: 2,
  gridLineWidth: 1,
  endOnTick: true,
  startOnTick: false,
  offset: 0,
  labels: {
    formatter: function () {
      let decimalPlace = 2;
      if (this.value < 1 && this.value > -1 && this.value !== 0) { // between -0.xx to 0.1
        try {
          decimalPlace = (this.value + '').match(/^0.(0+)/)[1].length + 1;
          decimalPlace += ((this.value + '').length - decimalPlace - 2) > 0 ? 1 : 0; // when receive 0.000xx (with two non-zero value), keep the 2 values.
        } catch (e) {}
      }

      return this.value.toFixed(decimalPlace);
    },
    style: tickFontStyle
  },
  title: {
    style: axisFontStyle
  }
};

export const credits = {
  text: ''
};

export const getProfileUrl = (sppObj, groupName) => {
  if (sppObj) {
    let sppName = sppObj.scientificName;
    if ([taxonomic.bird, taxonomic.mammal, taxonomic.amphibian, taxonomic.habitat].includes(groupName)) {
      sppName = sppObj.scientificName ?? sppObj.commonName;
    }
    const category = groupName === taxonomic.habitat ? 'habitat' : 'species';
    // no need to encode when use as path format, as if not, the decode will decode into html format
    // use special character to replace / (for path), + to preserve orginal -, - to connect spaces
    return sppName ? `/${category}/${sppName?.replaceAll('-', '+').replaceAll('.', '$').replaceAll(' ', '-').replaceAll('/', '@').replaceAll('>', '&gt;').replaceAll('<', '&lt;')?.toLowerCase()}` : '';
  } else {
    return '';
  }
}

/*
    const pathNames = (new URL(location.href).search ?? /category/name').split('&');
    tsn.value = pathNames.find(x => x );
    year.value = new URL(location.href).searchParams.get('year') ?? 2021;
  */

// 0: ""  1: "species" 2: "Phaeocalicium-compressulum"
export const getNameFromUrl = (defaultUrl) => {
  const pathNames = ((new URL(location.href).pathname.substring(1) || defaultUrl).replaceAll('//', '/').split('/')); // when no input pathname = /, so start from second letter for path checking
  // console.log(new URL(location.href).pathname.substring(1), defaultUrl, { pathNames });
  if (pathNames.length < 2) {
    return defaultUrl.split('/')[1];
  }
  return pathNames[1].replaceAll('-', ' ').replaceAll('$', '.').replaceAll('+', '-').replaceAll('@', '/').replaceAll('&gt;', '>').replaceAll('&lt;', '<');
}
